<template>
  <div>
    <b-row>
      <b-col
          id="categories"
          cols="3"
          class="stretch"
          style="height:100vh;
          color: #ecece6;
          background-color: #222222;"
      >
        <category-side
            :categories="appCategories"
        />
      </b-col>
      <b-col>
        <transition name="slide">
        <div v-if="mainView === 'myAppsView'">
          <b-row>
            <b-col>
              <hero-scroll-view />
            </b-col>
          </b-row>
          <hr style="border-color: #605f59" />
          <b-row style="margin-top: 15px;">
            <b-col>
              <h4 style="color: antiquewhite">
                <strong>
                  Best New Apps and Updates
                </strong>
              </h4>
            </b-col>
          </b-row>
          <b-row style="margin-top: 25px">
            <b-col>
              <my-apps
              @myapp-clicked="handleMyAppClick"
              />
            </b-col>
          </b-row>
        </div>
        </transition>
        <div v-if="mainView === 'myAppDetailView'">
          <my-app-detail-view
              :tool="selectedTool"
          @back-click="handleGoTo('myAppsView')"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import CategorySide from "./categorySide";
import HeroScrollView from "./heroScrollView";
import MyApps from "./myApps";
import MyAppDetailView from "./myAppDetailView";
import ItemsSidebar from "@/components/blockResources/_components/itemsSideBar";
export default {
  name: "Display_MyAppStore",
  mixins: [ResourceBlockDisplay],
  components: {
    ItemsSidebar,
    HeroScrollView,
    CategorySide,
    MyApps,
    MyAppDetailView
  },
  props: {
    btnDownloadTitle: {
      type: String,
      default: "Add Selected Widgets"
    },
    storeItems: {
      type: Array,
      default: () => []
    },
    userOwnedItems: {
      type: Array,
      default: () => []
    },
    selectedResources: {
      type: Array,
      default: () => []
    },
    shallFilterOutUserOwnedItems: {
      type: Boolean,
      default: true
    },
    // prop for title or name
    name: {
      type: String,
      default: "name"
    },
    // prop for uid or id - prefer uid
    uid: {
      type: String,
      default: "uid"
    },
    assetUrlPath: {
      type: String,
      default: ""
    }
  },
  created() {},
  mounted() {
    this.getApps();
  },
  computed: {
      ...mapGetters({
        profile: "user/profile",
        apps: "user/apps"
      }),
  },
  methods: {
    getApps() {
      this.$store.dispatch("user/getListApps").then(apps => {});
    },
    handleMyAppClick(item) {
      debugger;
      this.selectedTool = item;
      this.mainView="myAppDetailView";
    },
    handleGoTo(viewName){
      debugger;
      this.mainView = viewName;
    },
    filterOutUserOwnedItems(items) {

      let filteredItems2 = items.filter(o1 => {
        return !this.userOwnedItems.some(o2 => {
          return o1.uid === o2.uid; // assumes unique id
        });
      })
          .map(o => {
            // use reduce to make objects with only the required properties
            // and map to apply this to the filtered array as a whole
            return o;
          });
      return filteredItems2;
    },
    handleSlidingStart(numberSlidingTo) {},
    handleSlidingEnd(numberSlidingTo) {},
    handleOpenSideBar() {
      debugger;
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.sidebarModel = false;
    },
  },
  data() {
    return {
      mainView:'myAppsView',
      selectedTool: null,
      appCategories:[
        {
          _created_at:123,
          text:"(S)piritual"
        },
        {
          _created_at:123,
          text:"(H)ealth"
        },
        {
          _created_at:123,
          text:"(E)ducation"
        },
        {
          _created_at:123,
          text:"(F)inance"
        },
        {
          _created_at:123,
          text:"AI Suggests",
          bicon:"star-fill"
        },
        {
          _created_at:123,
          text:"Games",
          bicon: "dice5"
        },
        {
          _created_at:123,
          text:"Updates",
          bicon:"cloud-download-fill"
        }
      ],
      pauseSlideWithInterval: false,
      assetsURLHome: "", //assets/apps/myappstore/',
      audioDuration: null,
      sidebarId: "myapps-store-sidebar-1",
      sidebarModel: false,
      /* SLIDE INFO*/
      slideId: "store-slides",
      controls: false,
      indicators: false,
      noTouch: false,
      fadeTransition: false,
      slide: 0,
      sliding: null,
      settingsInterval:0,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      },
      /*MYAPP DATA */
      maxAmtofTools: 100,
      resources: [],
      tags: ["Cognition", "Services", "Reporting"],
      activeTags: [],
      showtools: "resources", //resources, display, search
      activeTools: [],
      searchStr: "",
      activeDisplayItem: {}
    }
  }
}
</script>

<style lang="scss" scoped></style>
